

/**情境/狀態 類型 */
export enum ClinicSessionTypeEnum
{
  /**院內 */
  Normal = 0,
  /**一般巡診 */
  OutVisit = 1,
  /**監獄巡診 */
  OutVisitJail = 2,
  /**醫缺巡診 */
  OutVisitMedLackArea = 3,
  /**山地離島巡診 */
  OutVisitMtn = 4,
}

